import { createFileRoute } from "@tanstack/react-router";
import ComoFunciona, { comoFuncionaHowTo } from "@/pages/ComoFunciona";
import { landingHead } from "@/lib/landingHead";

export const Route = createFileRoute("/como-funciona")({
  head: () => {
    const h = landingHead("howItWorks", "es");
    const img = "https://retaillemon.com/og-como-funciona.jpg";
    return {
      meta: [
        ...h.meta,
        { property: "og:image", content: img },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { property: "og:image:alt", content: "Comerciante revisando sus cuentas al cerrar la tienda" },
        { property: "og:site_name", content: "Retail Lemon" },
        { name: "twitter:image", content: img },
      ],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(comoFuncionaHowTo("es")) }],
    };
  },
  component: () => <ComoFunciona routeLang="es" />,
});
